import { render, staticRenderFns } from "./creat-mult-select.vue?vue&type=template&id=55a64fd2&scoped=true"
import script from "./creat-mult-select.vue?vue&type=script&lang=js"
export * from "./creat-mult-select.vue?vue&type=script&lang=js"
import style0 from "./creat-mult-select.vue?vue&type=style&index=0&id=55a64fd2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a64fd2",
  null
  
)

export default component.exports